import { TextButton, Combobox } from '@zillow/constellation';
import React from 'react';
import { ITaskEditFormDisplayProps } from './TaskEditForm';
import { Field, FieldProps } from 'formik';
import { useListPagedAdminUsersQuery } from 'API/administration/AdminUsersAPI';
import { eAdminAccountStatus } from 'types/administration/userAdministration/IAdminUser';
import { IEditField } from './formTools';
import { EditFieldControls } from './EditFieldControls';
import { FlexGrowFormField } from './FlexGrowFormField';

export const EditPersonDisplay: React.FC<ITaskEditFormDisplayProps & { fullName?: string }> = ({
  setIsEditing,
  fullName,
}) => {
  return (
    <TextButton buttonType={'primary'} onClick={setIsEditing} fontType={'bodySmall'} data-test-id="edit-person-display">
      {fullName ?? 'No Teammate'}
    </TextButton>
  );
};

export const EditPersonField: React.FC<IEditField & { fieldName: string }> = ({
  submitOnChange,
  fieldName,
  cancel,
}) => {
  const { data: adminUsers, isLoading: adminUsersIsLoading } = useListPagedAdminUsersQuery({
    status: eAdminAccountStatus.Active,
    fetchAll: true,
  });
  const teammates = adminUsers?.content.map((admin) => ({ label: admin.fullName, value: admin.id })) ?? [];
  return (
    <EditFieldControls fieldName={fieldName} cancel={cancel}>
      <Field name={fieldName}>
        {({ field, form }: FieldProps) => (
          <FlexGrowFormField>
            <Combobox
              placeholder="Select a person..."
              value={field.value ?? ''}
              onChange={(value, meta: any) => {
                form.setFieldValue(field.name, meta.option.value);
                submitOnChange && form.submitForm();
              }}
              options={teammates}
              loading={adminUsersIsLoading}
              showLabelForValue
            />
          </FlexGrowFormField>
        )}
      </Field>
    </EditFieldControls>
  );
};
